(() => {
  const q = (s, c = document) => c.querySelector(s);
  const qa = (s, c = document) => [...c.querySelectorAll(s)];
  const money = (cents, currency) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency }).format(cents / 100);
  const offer = q('[data-drp-offer]');
  const route = (target) => {
    const el = target === 'size' ? q('[data-drp-anchor="size"]') : offer;
    el?.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    setTimeout(() => el?.querySelector('input, button')?.focus({ preventScroll: true }), 450);
  };
  qa('[data-drp-route]').forEach((b) => b.addEventListener('click', () => route(b.dataset.drpRoute)));
  if (!offer) return;
  const data = JSON.parse(q(`#${CSS.escape(offer.dataset.productJsonId)}`).textContent);
  const optionNames = data.options || [];
  const pairs = q('.drp__pair-list', offer);
  const template = q('[data-pair-template]', offer);
  const error = q('.drp__error', offer);
  const add = q('[data-drp-add]', offer);
  const sticky = q('[data-drp-sticky]');
  const stickyAction = q('[data-drp-sticky-action]');
  let count = 1;

  function valuesAt(index) { return [...new Set(data.variants.map(v => v.options[index]))]; }
  function findVariant(fieldset) {
    const selected = qa('select', fieldset).map(s => s.value);
    return data.variants.find(v => v.options.every((o, i) => o === selected[i]));
  }
  function update() {
    let valid = true;
    qa('.drp__pair', pairs).forEach(fs => {
      const v = findVariant(fs); const note = q('.drp__availability', fs);
      fs.dataset.variantId = v?.id || '';
      note.textContent = !v ? 'This combination does not exist.' : v.available ? `${v.title} — ${money(v.price, offer.dataset.currency)}` : 'Sold out';
      valid = valid && Boolean(v?.available);
    });
    add.disabled = !valid;
    const target = Number(offer.dataset[`bundle${count}Cents`] || data.variants[0].price * count);
    q('[data-drp-total]', offer).textContent = money(target, offer.dataset.currency);
    if (sticky) {
      q('[data-drp-sticky-selection]', sticky).textContent = valid ? `${count} pair${count > 1 ? 's' : ''} selected` : 'Complete all selections';
      stickyAction.textContent = valid ? `Add to Cart — ${money(target, offer.dataset.currency)}` : 'Choose size & color';
    }
  }
  function render() {
    pairs.replaceChildren();
    for (let p = 0; p < count; p++) {
      const node = template.content.cloneNode(true); const fs = q('fieldset', node);
      q('[data-pair-number]', node).textContent = p + 1;
      const options = q('.drp__options', node);
      optionNames.forEach((name, i) => {
        const label = document.createElement('label'); label.textContent = name;
        const select = document.createElement('select'); select.name = `pair-${p + 1}-${name}`; select.setAttribute('aria-label', `Pair ${p + 1} ${name}`);
        valuesAt(i).forEach(value => select.add(new Option(value, value)));
        select.addEventListener('change', update); label.append(select); options.append(label);
      });
      pairs.append(node);
    }
    update();
  }
  qa(`input[name="bundle-${offer.id.replace('drp-offer-', '')}"]`, offer).forEach(r => r.addEventListener('change', () => { count = Number(r.value); render(); }));
  add.addEventListener('click', async () => {
    error.hidden = true; add.disabled = true; add.setAttribute('aria-busy', 'true');
    const items = qa('.drp__pair', pairs).map((fs, i) => ({ id: Number(fs.dataset.variantId), quantity: 1, properties: { '_Bundle': `${count}-pair`, 'Pair': String(i + 1) } }));
    try {
      const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items }) });
      const body = await res.json(); if (!res.ok) throw new Error(body.description || 'Could not add this bundle.');
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: body }));
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: body }));
      window.location.assign(`${window.Shopify?.routes?.root || '/'}cart`);
    } catch (e) { error.textContent = e.message; error.hidden = false; error.focus(); add.disabled = false; }
    finally { add.removeAttribute('aria-busy'); }
  });
  stickyAction?.addEventListener('click', () => add.disabled ? route('offer') : add.click());
  render();
})();
